import http from "@/common/http"

export const detail = (id) =>{
  return http({
    url:"/cont/restaurant/detail",
    method:"get",
    data:{
      id
    }
  })
}

export const list = (data) =>{
  return http({
    url:"/cont/restaurant/list",
    method:"post",
    data:data
  })
}

export default {
  detail,
  list
}



// WEBPACK FOOTER //
// ./src/services/client/cont/restaurant.js